import type { SVGProps } from 'react';

const SvgNotModified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 18H6c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h3c.55 0 1-.45 1-1s-.45-1-1-1H6C4.35 4 3 5.35 3 7v10c0 1.65 1.35 3 3 3h4c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M10 14H9v-1.59l5-5L15.59 9l-.29.29a.996.996 0 1 0 1.41 1.41l3-3c.06-.06.55-.56.8-1.33.37-1.1.08-2.2-.8-3.09-1.62-1.62-3.53-.89-4.41 0l-8.01 8.01A1 1 0 0 0 7 12v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1m8.29-9.29c.67.67.28 1.29 0 1.59L17 7.59 15.41 6l1.29-1.29c.31-.29.92-.68 1.59 0m2.39 9.61A4.47 4.47 0 0 0 17.5 13c-1.2 0-2.33.47-3.18 1.32S13 16.3 13 17.5s.47 2.33 1.32 3.18S16.3 22 17.5 22s2.33-.47 3.18-1.32S22 18.7 22 17.5s-.47-2.33-1.32-3.18m-1.41 1.41c.47.47.73 1.1.73 1.77 0 .32-.06.62-.17.91l-3.24-3.24c.29-.11.59-.17.91-.17.67 0 1.3.26 1.77.73m-3.54 3.54c-.47-.47-.73-1.1-.73-1.77 0-.32.06-.62.17-.91l3.22 3.22c-.9.33-1.97.15-2.67-.55z"
    />
  </svg>
);
export default SvgNotModified;
